import React from 'react';

export default function OrdersTable() {
	return (
		<div className="table-view table-responsive">
			<table id="orders-table" className="table">
				<thead>
					<tr>
						<th>
							<i style={{ fontSize: '1.5em' }} className="fa fa-cog icon" />
						</th>
						<th>Order No</th>
						<th>Order Date</th>
						<th>Required Date</th>
						<th>Customer Code</th>
						<th>Customer Name</th>
						<th>Customer Ref</th>
						<th>Warehouse</th>
						<th>Status</th>
						<th>Currency</th>
						<th>Cost(PKR) </th>
						<th>Margin</th>
						<th>Sub Total(PKR)</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
